export default function ViewReportDirective() {
  return {
    restrict: 'E',
    template: require('./view-report.directive.html'),
    scope: {
      reportInstanceId: '@',
      tooltip: '@',
      tooltipAppendToSelector: '@',
      iconType: '@',
      iconSizeClass: '@',
      iconColorClass: '@',
    },
    controller: 'ViewReportDirectiveController',
    controllerAs: 'viewReportVM',
    bindToController: true,
    replace: true,
  };
}
